import { DependencyType } from 'common';

export type RelationshipColors = {
  [r in DependencyType]: {
    color: string,
    source: 'entity' | 'activity',
    target: 'entity' | 'activity',
  }
};

export const relationshipColors: RelationshipColors = {
  'Generated by': {
    color: 'blue',
    source: 'entity',
    target: 'activity',
  },
  'Used': {
    color: 'black',
    source: 'activity',
    target: 'entity',
  },
//    'Related to': {
//    // We may want to remove this if this relationship isn't used
//    // Also we may want to customize these values
//    color: 'yellow',
//    source: 'entity',
//    target: 'entity',
//  },
};

export const NODE_OUTLINE = 'rgb(22, 89, 136)';
export const SELECTED_NODE_OUTLINE = '#c0571e';
export const VALID_ENDPOINT_OUTLINE = 'rgb(55, 130, 33)';
export const INVALID_ENDPOINT_OUTLINE = 'rgb(130, 55, 33)';
export const NODE_HEIGHT = 40;
export const NODE_RADIUS = 10;
export const STUDY_STROKE = 'rgb(0, 0, 0)';
export const STUDY_WIDTH = 50;
export const IS_MOBILE = /Mobi|Android/i.test(navigator.userAgent);

